import M from 'moment'
import API from './Api'
import * as R from 'ramda'
import React from 'react'

export async function buttonAccess(formId, callback) {
    let payload = {
        formId: formId,
    }

    let button = {
        btnSearch: "disable",
        btnClear: "disable",

        btnEdit: "hidden",
        btnDelete: "hidden",
        btnDetail: "hidden",
        btnPrint: "hidden",
        btnDownloadGrid: "hidden",
        btnTree: "hidden",
        btnPaklaring: "hidden",

        //grid MUI
        btnAdd: false,
        btnUpload: false,
        btnDownload: false,
        btnGenerate: false,
    };

    API.create('EKSAD').postAuthGetButtonAccess(payload).then(
        (res) => {
            if (res.ok && res.data.status === 'S') {
                res.data.data.buttonAccess.map((item) => {
                    if (item.access == 'btnSearch') {
                        button.btnSearch = 'enable';
                    }
                    if (item.access == 'btnClear') {
                        button.btnClear = 'enable';
                    }
                    if (item.access == 'btnEdit') {
                        button.btnEdit = 'visible';
                    }
                    if (item.access == 'btnDelete') {
                        button.btnDelete = 'visible';
                    }
                    if (item.access == 'btnDetail') {
                        button.btnDetail = 'visible';
                    }
                    if (item.access == 'btnPrint') {
                        button.btnPrint = 'visible';
                    }
                    if (item.access == 'btnTree') {
                        button.btnTree = "visible";
                    }
                    if (item.access == 'btnPaklaring') {
                        button.btnPaklaring = "visible";
                    }

                    //grid MUI
                    if (item.access == 'btnAdd') {
                        button.btnAdd = true;
                    }
                    if (item.access == 'btnUpload') {
                        button.btnUpload = true;
                    }
                    if (item.access == 'btnDownload') {
                        button.btnDownload = true;
                        button.btnDownloadGrid = "visible";
                    }
                    if (item.access == 'btnGenerate') {
                        button.btnGenerate = true;
                    }
                })
            }

            callback(button)
        });
}
